<template>
    <div class="pt-8">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Settings</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <div class="space-y-1 top-1">
                <div class="relative">
                    <div class="border-t border-gray-200 my-3"></div>
                    <div class="absolute inset-0 flex items-center justify-center">
                        <div class="text-xs px-2 py-1 bg-gray-50 text-gray-400 font-semibold">
                            Options
                        </div>
                    </div>
                </div>
                <div class="flex w-full ">
                    <label class="mt-1 text-gray-700 align-baseline font-medium flex-1 flex-grow">Show
                        Omitted Items</label>
                    <ui-toggle v-model="showOmittedState"
                               @input="(e) => $emit('toggleShowOmittedState', e)"
                               class="inline-block w-auto flex p-0.5 rounded-xl"></ui-toggle>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";

export default {
    components: {UiToggle},
    props: {
        showOmitted: Boolean,
    },
    data() {
        return {
            showOmittedState: this.showOmitted,
        }
    },
    methods: {
    },
}
</script>
